import { render, staticRenderFns } from "./OptimizationTopTabs.vue?vue&type=template&id=3115c27e&scoped=true"
import script from "./OptimizationTopTabs.vue?vue&type=script&lang=js"
export * from "./OptimizationTopTabs.vue?vue&type=script&lang=js"
import style0 from "./OptimizationTopTabs.vue?vue&type=style&index=0&id=3115c27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115c27e",
  null
  
)

export default component.exports